// ======================================================================
// File Name       : serviceRecord
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../constants/actionTypes/serviceRecord';

export function receiveRecordList(resdata, url) {
  return {
    type: ActionTypes.SERVICE_RECORD_RECEIVE_LIST,
    data: resdata,
    url,
  };
}

export function receiveServiceList(serviceInfo) {
  return {
    type: ActionTypes.SERVICE_EDITING_LIST,
    serviceInfo,
  };
}

export function saveSystemUsageMonths(systemUsageMonths) {
  return {
    type: ActionTypes.SAVE_SYSTEM_USAGE_MONTHS,
    systemUsageMonths,
  };
}
